module.exports = __webpack_public_path__ + "media/img/auth/campus-cap-241c31d15440c849b7bc6fc8a0efe9cb.jpg";